import { SVGProps } from 'react';

import { Root } from './Icon.ui';
import { mapComponentByName } from './helpers/mapComponentByName';

export type IconProps = SVGProps<SVGSVGElement> & {
  name: keyof typeof mapComponentByName;
  width?: number;
};

export const Icon = (props: IconProps) => {
  const { name, ...svgProps } = props;

  const IconComponent = mapComponentByName[name];

  return <Root {...svgProps} as={IconComponent} />;
};
